// extracted by mini-css-extract-plugin
export default {"container":"NotAuthorized_container__fcz5U","inner_container":"NotAuthorized_inner_container__g6rlQ"};